function updateVariantUI(variant) {
  if (!variant) return;

  // ✅ Update title
  const titleEl = document.querySelectorAll(".variant-title");



  if (titleEl) {

    titleEl.forEach((el) => {

      if(variant.title == 'Default Title'){
        el.textContent = ""
      }
      else{
      el.textContent = variant.title;
      }
    });
  }

  // ✅ Show/Hide section
  const sections = document.querySelectorAll(".custom-icon-box");

  sections.forEach((section) => {
    if (variant.option1 === "Brand New") {
      section.style.display = "none";
    } else {
      section.style.display = "block";
    }
  });
}

// ✅ Initial load
document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector('[name="id"]');
  if (!input || !window.productData) return;

  const variantId = input.value;

  const selectedVariant = window.productData.variants.find(
    (v) => String(v.id) === String(variantId),
  );

  updateVariantUI(selectedVariant);
});

// ✅ Variant change
document.addEventListener("variant:change", function (event) {
  updateVariantUI(event.detail.variant);
});
